<div *ngIf="isVisible" class="side-panel absolute w-80 h-full bg-white" [@openClose]>
    <ng-container *ngTemplateOutlet="currentTemplate">
    </ng-container>
</div>